import React from 'react';

const DataListField = (
    { input, label, options, className, placeholder, meta: { touched, error } },
) => {
    const hasError = touched && error;
    const invalidClassName = hasError ? 'invalid' : '';

    return (
        <div className={`form-group ${invalidClassName}`}>
            <label className="form-control-label">{label}</label>
            <input list="banks" className={className} placeholder={placeholder} {...input} />
            <datalist id="banks">
              {options}
            </datalist>
            {hasError &&
                <div className="text-danger small pt-2 pl-2 animated flash">{error}</div>
            }
        </div>
    );
};

export default DataListField;



// WEBPACK FOOTER //
// ./src/Common/components/DataListField.js